import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '../../store/Reducers/AuditLogSlice';
import { AuditLogDatagrid } from '../../components/DataGrid/AuditLog/AuditLogDatagrid';

export const AuditLogPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
    };
  }, [dispatch]);

  return <AuditLogDatagrid />;
};
